import Vue from 'vue'
import CartButton from './components/sp/common/CartButton'
import MypageButton from './components/sp/common/MypageButton'
import UserStateBar from './components/sp/common/UserStateBar'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#cart-button',
  render: h => h(CartButton)
})

new Vue({
  el: '#mypage-button',
  render: h => h(MypageButton)
})

new Vue({
  el: '#user-state-bar',
  render: h => h(UserStateBar)
})



// WEBPACK FOOTER //
// ./src/header-parts.js